import { useQuery } from "@tanstack/react-query";
import { getProfitAndLoss } from "@/services/profit-and-loss-api";
import type { ProfitAndLossData } from "@/types/profit-and-loss-api";

type YM = { year: number; month: number };
type RangeFilter = { from: YM; to: YM };

export function useProfitAndLoss(
  clientId: string,
  connectionId: string,
  dateRange: RangeFilter,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["pnl-overview-range", clientId, connectionId, dateRange],
    enabled,
    queryFn: async (): Promise<ProfitAndLossData> => {
      return getProfitAndLoss(
        clientId,
        [connectionId],
        dateRange.from.year,
        dateRange.from.month,
        dateRange.to.year,
        dateRange.to.month
      );
    },
  });
}
